module.exports = __webpack_public_path__ + "static/images/icon-google.0f9252277b1441b28d2cfffc30a9f621.svg";